module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYBIhL3WMIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAElBMVEX4+MhokPCAeHCY2Nj4+Pj////3NgmLAAAAAXRSTlMAQObYZgAAAAFiS0dEBfhv6ccAAABiSURBVAjXZY7BDcNACARRXAGEArwrCkjkDlb0X5MfvnuQzI+RZoUd1+BjXx+8zX8wd7lS2dVqbaGiilRhi4QSrhyisROpG0pCj+iS6knWRqxEawNOBhgkA/7/GOYd9uLgvAEe6Rz1HcsGrgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Water.png
// module id = 174
// module chunks = 0